import $ from 'jquery';
import isTouchDevice from "./helpers/isTouchDevice";
export default function menuInit() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const navbar = document.querySelector('header .navbar');
    const header = document.querySelector('header');


    const toggler = navbar.querySelector('.navbar-toggler');
    toggler.addEventListener('click', ev => {
        if(!toggler.classList.contains('collapsed')){
            let scrollTo = toggler.getAttribute('data-scroll-y');
            window.scrollTo({top: scrollTo*1, left: 0, behavior: "instant"});
            document.body.classList.remove('menu-open');
        }else{
            toggler.setAttribute('data-scroll-y', window.scrollY);
            document.body.classList.add('menu-open');

        }
    })

    $(function ($) {
        $(function ($) {
            if (vw >= 1199 && !isTouchDevice() ) {

                const allFormerParents = document.querySelectorAll('.dropdown-item-former-parent');
                if(allFormerParents.length > 0){
                    allFormerParents.forEach(p =>{
                        p.parentElement.removeChild(p);
                    })
                }
                $('.navbar .dropdown').hover(function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

                }, function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(600).slideUp();

                });
                $('.navbar .ume-sub-sub-holder').hover(function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(200).slideDown();

                }, function () {
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(800).slideUp();

                });
                $('.navbar .dropdown  a').click(function () {
                    if(this.getAttribute('target')!== '_blank'){
                        location.href = this.href;
                    }

                });

            }


        });


    });
    $(function ($) {
        if (vw >= 1199 && isTouchDevice()) {
            document.addEventListener('click', ev => {
                if(!ev.target.classList.contains('dropdown-toggle')) return
                const container = ev.target.nextElementSibling;
                const subMenus = container.querySelectorAll('.ume-sub-sub-holder');
                if(subMenus.length > 0){
                    subMenus.forEach( subMenu => {
                        const target = subMenu.querySelector('.dropdown-menu__side');
                        target.classList.remove('show');
                    })
                }

            })
            const navbar = document.querySelector('.navbar-nav');
            const dropdowns = document.querySelectorAll('.dropdown-menu');
            if(dropdowns.length > 0){
                dropdowns.forEach(dropdown => {
                    if(!dropdown.querySelector('.dropdown-item-former-parent')){
                        const triggerLink = dropdown.previousElementSibling;
                        const subMenus = dropdown.querySelectorAll('.ume-sub-sub-holder');
                        if (triggerLink.getAttribute('href') !== '#' && triggerLink.getAttribute('href') !== '#!') {
                            const insertLink = triggerLink.cloneNode(true);
                            insertLink.classList = 'dropdown-item dropdown-item-former-parent';
                            insertLink.setAttribute('data-toggle', '');
                            dropdown.insertBefore(insertLink, dropdown.firstChild);
                        }
                        if(subMenus.length > 0){
                            subMenus.forEach(subMenu => {
                                const link = subMenu.firstElementChild;
                                if(!link.getAttribute('data-ev-listener')){
                                    link.addEventListener('click', ev => {
                                        subMenus.forEach(m =>{
                                            if(subMenu !== m){
                                                let l = m.firstElementChild;
                                                m.classList.remove('show');
                                                let tC = l.nextElementSibling;
                                                tC.classList.remove('show');
                                            }

                                        })
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        const targetContainer = link.nextElementSibling;
                                        targetContainer.classList.toggle('show');
                                        subMenu.classList.toggle('show');
                                        document.addEventListener('click', ev => {
                                            if(ev.target == targetContainer) return;
                                            targetContainer.classList.remove('show');
                                            subMenu.classList.remove('show');

                                        });
                                    });
                                    link.setAttribute('data-ev-listener', 'true');
                                }

                            })
                        }
                    }


                })
            }


        }

    })
    $(function ($) {
        if (vw < 1200) {
            const navbarToggle = document.querySelector('[data-target="#pingunautenMainMenu"]');
            document.addEventListener('click', ev => {

                const matches = ev.target.matches ? ev.target.matches('.dropdown-item') : ev.target.msMatchesSelector('.dropdown-item');
                if (matches && ev.target.parentElement.classList.contains('dropdown-menu')) {
                    navbarToggle.click();
                } else return;
            });
            const mainMenuParent = document.getElementById('pingunautenMainMenu');
            const mainMenuList = mainMenuParent.querySelector('.navbar-nav');

            let parents = [];
            if (mainMenuList !== null) {
                parents = mainMenuList.querySelectorAll('.menu-item-has-children');
            }

            if (parents.length > 0) {
                parents.forEach(parent => {
                    const link = parent.getElementsByTagName('a');
                    const dropdown = parent.querySelector('.dropdown-menu');
                    // sub top level parents
                    if(!dropdown.querySelector('.dropdown-item-former-parent')){
                        checkSubParents(dropdown);
                        if (link[0].getAttribute('href') === '#' || link[0].getAttribute('href') === '#!') return;
                        const newLink = link[0].cloneNode(true);
                        newLink.classList.add('dropdown-item');
                        newLink.classList.add('dropdown-item-special');
                        newLink.classList.add('dropdown-item-former-parent');
                        newLink.classList.remove('dropdown-toggle');
                        newLink.classList.remove('nav-link');
                        newLink.removeAttribute('data-toggle');
                        dropdown.insertBefore(newLink, dropdown.firstChild);
                    }



                })
            }


        }

    })

    function checkSubParents(parentElement){
        const subParents = parentElement.querySelectorAll('.ume-sub-sub-holder');
        if (subParents.length > 0){
            subParents.forEach(parent => {
                const link = parent.querySelector('.dropdown-item');
                const dropdown = parent.querySelector('.dropdown-menu');
                if (link.getAttribute('href') === '#') return;
                const newLink = link.cloneNode(link);
                newLink.classList.add('ume-nav-mobile-new-link');
                newLink.classList.remove('dropdown-item');
                link.classList.add('dropdown-item__active');
                newLink.removeAttribute('data-toggle');
                newLink.removeAttribute('aria-expanded');
                link.removeAttribute('data-toggle');
                link.removeAttribute('aria-expanded');
                newLink.innerHTML = '';
                const newDiv = document.createElement('div');
                newDiv.classList.add('ume-nav-mobile-new-container');
                newDiv.appendChild(link);
                newDiv.appendChild(newLink);
                parent.insertBefore(newDiv, dropdown);
                parent.addEventListener('click', ev => {
                    if (!ev.target.classList.contains('dropdown-item__active')) return;
                    ev.preventDefault();
                    dropdown.classList.toggle('d-block')
                })

            });
        }

    }



}